// extracted by mini-css-extract-plugin
export default {"userBox":"events_userBox__fc+Tm","paramsBox":"events_paramsBox__szJT5","btnBox":"events_btnBox__Jf0Xa","desBox":"events_desBox__7V4gQ"};